import { render } from "./Keyboard.vue?vue&type=template&id=bc0a9d76"
import script from "./Keyboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Keyboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Keyboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc0a9d76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc0a9d76', __exports__)) {
    api.reload('bc0a9d76', __exports__)
  }
  
  module.hot.accept("./Keyboard.vue?vue&type=template&id=bc0a9d76", () => {
    api.rerender('bc0a9d76', render)
  })

}


export default __exports__